// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"692":"efb14c4e","884":"f1641062"}[chunkId] + ".chunk.js";
};